import HomeworkIdeasView from "@features/tools/view/homework-ideas-view";

const HomeworkIdeas = () => {
  return <HomeworkIdeasView />;
};

export default HomeworkIdeas;
